import { defineMessages } from 'react-intl'

export const renameDomainMessages = defineMessages({
  title: {
    id: 'renameDomain.title',
    description: 'A title of modal allowing to rename Group/Domain',
    defaultMessage: 'Rename group {domainName}',
  },
  input: {
    id: 'renameDomain.input',
    description: "Input's placeholder for the name for renamed Group/Domain",
    defaultMessage: 'Name',
  },
  alreadyExists: {
    id: 'renameDomain.alreadyExists',
    description:
      'Error message for already existing name for new nested Group/Domain',
    defaultMessage: 'Group Name should be unique',
  },
})
